module.exports = __webpack_public_path__ + "static/media/female-founder-collective.ec9ba801.png";